(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1404],{

/***/ 24935:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telemedicine/request-complete",
      function () {
        return __webpack_require__(82080);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* harmony import */ var _DefaultButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47641);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  margin: 0 auto;\n  margin-top: auto;\n  width: 100%;\n  z-index: 50;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px 16px;\n\n  div + div {\n    margin-left: 10px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 32px;\n  width: 100%;\n\n  right: 0;\n  top: -32px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 7;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 12px;\n  padding: 17px;\n  height: 60px;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 3;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var StickyButton = function(_param) {
    var children = _param.children, _hasGradient = _param.hasGradient, hasGradient = _hasGradient === void 0 ? true : _hasGradient, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "hasGradient"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StickyButtonContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: "stickyButton"
    }, props), {
        children: [
            hasGradient && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapperGradient, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapper, {
                children: children
            })
        ]
    }));
};
var Button = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
var SubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
var WhiteSubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWhiteSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
StickyButton.Button = Button;
StickyButton.SubButton = SubButton;
StickyButton.WhiteSubButton = WhiteSubButton;
/* harmony default export */ __webpack_exports__["Z"] = (StickyButton);
var StickyButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-0"
})(_templateObject());
var StickyButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    max-width: ".concat(theme.size.tablet, ";\n    background-color: ").concat(theme.color.white, ";\n  ");
});
var StickyButtonWrapperGradient = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-2"
})(_templateObject2());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-3"
})(_templateObject3());
var StyledDefaultButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_DefaultButton__WEBPACK_IMPORTED_MODULE_2__/* .DefaultButtonStyled */ .qY).withConfig({
    componentId: "sc-7e5c5516-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    \n    & > span, & > h2 {\n      ").concat(theme.typography.UI18SB, ";\n      color: ").concat(theme.color.white, ";\n    }\n  \n    &:disabled {\n      background: ").concat(theme.color.gray200, ";\n    }\n  ");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    &: active:not(:disabled) {\n      background: ").concat(theme.color.primary700, ";\n    }\n  ");
});
var SubButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-6"
})(_templateObject6());
var StyledSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray700, ";\n    &: active {\n      background: ").concat(theme.color.gray800, ";\n    }\n  ");
});
var StyledWhiteSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    color: ").concat(theme.color.gray600, ";\n    border: 1px solid ").concat(theme.color.gray100, ";\n    \n    &: active {\n      background: ").concat(theme.color.white, ";\n    }\n  ");
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-7e5c5516-9"
})(_templateObject9());


/***/ }),

/***/ 53157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _hooks_useLogger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8202);



var ClickLogger = function(props) {
    var children = props.children, _params = props.params, eventName = _params.eventName, payload = _params.payload, _enabled = props.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var log = (0,_hooks_useLogger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().log;
    var child = react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children);
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!enabled) {
            return;
        }
        var handleLog = function(_e) {
            var evaluatedPayload = typeof payload === "function" ? payload() : payload;
            log({
                eventName: eventName,
                payload: evaluatedPayload
            });
        };
        var wrapper = wrapperRef.current;
        if (wrapper) {
            wrapper.addEventListener("click", handleLog, {
                capture: true
            });
            return function() {
                wrapper.removeEventListener("click", handleLog, {
                    capture: true
                });
            };
        }
    }, [
        eventName,
        payload,
        log,
        enabled
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: "contents",
        children: child
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClickLogger);


/***/ }),

/***/ 36444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G0": function() { return /* binding */ EWebDiagnosisInflowType; },
/* harmony export */   "Js": function() { return /* binding */ TreatmentRequestLog; },
/* harmony export */   "o5": function() { return /* binding */ EWebTreatmentRequestLog; },
/* harmony export */   "pj": function() { return /* binding */ EScheduleModeForLog; }
/* harmony export */ });
/* unused harmony export logs */
var TreatmentRequestLog;
(function(TreatmentRequestLog) {
    TreatmentRequestLog["RequestPageIn"] = "request_page_in";
    TreatmentRequestLog["RequestPageInWithTargetDate"] = "request_page_in_with_target_date";
    TreatmentRequestLog["RequestPageInWithoutTargetDate"] = "request_page_in_without_target_date";
    TreatmentRequestLog["RequestClickBookingTime"] = "request_click_booking_time";
    TreatmentRequestLog["RequestSuccessSsn"] = "request_success_ssn";
    TreatmentRequestLog["RequestMoveToPaymentStep"] = "request_move_to_payment_step";
    TreatmentRequestLog["RequestClickNonBenefitCategory"] = "request_click_non_benefit_category";
    TreatmentRequestLog["RequestOpenNonBenefitCategory"] = "request_open_non_benefit_category";
    TreatmentRequestLog["RequestUploadImage"] = "request_upload_image";
    TreatmentRequestLog["RequestPrevStepFromDiagnosis"] = "request_prev_step_from_diagnosis";
    TreatmentRequestLog["RequestPrevStepFromPayment"] = "request_prev_step_from_payment";
    TreatmentRequestLog["RequestClickContinueInModal"] = "request_click_continue_in_modal";
    TreatmentRequestLog["RequestClickStopInModal"] = "request_click_stop_in_modal";
    TreatmentRequestLog["RequestClickAutoAgreementCheck"] = "request_click_auto_agreement_check";
    TreatmentRequestLog["RequestSubmitClick"] = "request_submit_click";
    TreatmentRequestLog["RequestManualOpenCategory"] = "request_manual_open_category";
    TreatmentRequestLog["RequestAutoOpenCategory"] = "request_auto_open_category";
    TreatmentRequestLog["RequestSelectCategory"] = "request_select_category";
    TreatmentRequestLog["RequestPageInQuickMatch"] = "request_page_in_quick_match";
    TreatmentRequestLog["RequestOpenLoadDetailSymptoms"] = "request_open_load_detail_symptoms";
    TreatmentRequestLog["RequestSelectLoadDetailSymptom"] = "request_select_load_detail_symptom";
    TreatmentRequestLog["ImpressedChildInfoSection"] = "impressed_child_info_section";
})(TreatmentRequestLog || (TreatmentRequestLog = {}));
var EWebTreatmentRequestLog;
(function(EWebTreatmentRequestLog) {
    EWebTreatmentRequestLog["CategorySelectItemClick"] = "category_select_item_click";
    EWebTreatmentRequestLog["RequestStepChangeToDiagnosis"] = "web_request_step_change_to_diagnosis";
    EWebTreatmentRequestLog["RequestStepChangeToDoctor"] = "web_request_step_change_to_doctor";
    EWebTreatmentRequestLog["RequestStepChangeToPayment"] = "web_request_step_change_to_payment";
    EWebTreatmentRequestLog["RequestStepChangeToCertificationGuide"] = "web_request_step_change_to_certification_guide";
    EWebTreatmentRequestLog["ClickNextFromDiagnosisStep"] = "click_next_from_diagnosis_step";
    EWebTreatmentRequestLog["ClickCompleteButton"] = "click_complete_button";
    EWebTreatmentRequestLog["ClickTelemedicineRequestInDoctorDetail"] = "click_telemedicine_request_in_doctor_detail";
    EWebTreatmentRequestLog["OpenDoctorDetail"] = "open_doctor_detail";
    EWebTreatmentRequestLog["CloseDoctorDetail"] = "close_doctor_detail";
    EWebTreatmentRequestLog["ClickSelectCardCompany"] = "click_select_card_company";
    EWebTreatmentRequestLog["ClickSelectCard"] = "click_select_card";
    EWebTreatmentRequestLog["ClickAddCreditCard"] = "click_add_credit_card";
    EWebTreatmentRequestLog["ClickAddKakaoPay"] = "click_add_kakao_pay";
    EWebTreatmentRequestLog["ClickOpenInstallment"] = "click_open_installment";
    EWebTreatmentRequestLog["ClickTogglePoint"] = "click_toggle_point";
    EWebTreatmentRequestLog["ClickAgreement"] = "click_agreement";
    EWebTreatmentRequestLog["ClickAllAgreement"] = "click_all_agreement";
    EWebTreatmentRequestLog["ClickAgreementLink"] = "click_agreement_link";
    EWebTreatmentRequestLog["ClickSubmitDiagnosis"] = "click_submit_diagnosis";
    EWebTreatmentRequestLog["ClickCtaButton"] = "click_cta_button";
    EWebTreatmentRequestLog["ClickIdvSheet"] = "click_idv_sheet";
    EWebTreatmentRequestLog["ClickCloseButton"] = "click_close_button";
    EWebTreatmentRequestLog["ClickDoctorPro"] = "click_doctor_pro";
    EWebTreatmentRequestLog["ClickDoctorSort"] = "click_doctor_sort";
    EWebTreatmentRequestLog["ClickReqDoctorSelect"] = "click_req_doctor_select";
    EWebTreatmentRequestLog["ClickRequestTime"] = "click_request_time";
    EWebTreatmentRequestLog["ClickRequestTypeOpen"] = "click_request_type_open";
    EWebTreatmentRequestLog["ClickIdvSheetClose"] = "click_idv_sheet_close";
    EWebTreatmentRequestLog["ClickWebDiagnosisToRequest"] = "click_web_diagnosis_to_request";
    EWebTreatmentRequestLog["ClickWebDiagnosisToCategories"] = "click_web_diagnosis_to_categories";
    EWebTreatmentRequestLog["ClickQuickScheduleMode"] = "click_quick_schedule_mode";
    EWebTreatmentRequestLog["ClickGeneralScheduleMode"] = "click_general_schedule_mode";
    EWebTreatmentRequestLog["ClickDoctorFilterOption"] = "click_doctor_filter_option";
    EWebTreatmentRequestLog["ClickNextFromDoctorFilter"] = "click_next_from_doctor_filter";
    EWebTreatmentRequestLog["ClickLoadMoreDoctorsButton"] = "click_load_more_doctors_button";
})(EWebTreatmentRequestLog || (EWebTreatmentRequestLog = {}));
var logs = {
    request_page_in: "진료신청서 진료신청 페이지 진입",
    request_page_in_with_target_date: "진료신청서 진료신청 페이지 진입(예약 날짜 선택)",
    request_page_in_without_target_date: "진료신청서 진료신청 페이지 진입(예약 날짜 미선택)",
    request_click_auto_agreement_check: "진료신청서 자동 동의 체크 클릭",
    request_click_booking_time: "진료신청서 예약 시간 클릭",
    request_click_continue_in_modal: "진료신청서 이탈 모달 내 계속 작성 클릭",
    request_click_stop_in_modal: "진료신청서 이탈 모달 내 그만두기 클릭",
    request_click_non_benefit_category: "진료신청서 내 비급여 카테고리 클릭",
    request_open_non_benefit_category: "진료신청서 내 비급여 카테고리 오픈",
    request_submit_click: "진료신청서 진료 신청",
    request_move_to_payment_step: "진료신청서 결제 단계로 이동",
    request_prev_step_from_diagnosis: "진료신청서 진료신청 단계에서 이전으로 이동",
    request_prev_step_from_payment: "진료신청서 결제 단계에서 이전으로 이동",
    request_success_ssn: "진료신청서 주민번호 입력 완료",
    request_upload_image: "진료신청서 사진 업로드",
    request_manual_open_category: "진료신청서 카테고리 바텀시트 클릭",
    request_auto_open_category: "진료신청서 카테고리 바텀시트 자동 오픈",
    request_select_category: "진료신청서 카테고리 선택",
    request_page_in_quick_match: "진료신청서 퀵매치 진료신청 페이지 진입",
    request_open_load_detail_symptoms: "진료신청서 증상 불러오기 바텀시트 오픈",
    request_select_load_detail_symptom: "진료신청서 증상 불러오기 상세증상 선택",
    impressed_child_info_section: "진료신청서 아이 정보 섹션 노출"
};
var EWebDiagnosisInflowType;
(function(EWebDiagnosisInflowType) {
    EWebDiagnosisInflowType["QnaDetail"] = "qna_detail";
    EWebDiagnosisInflowType["MagazineDetail"] = "magazine_detail";
    EWebDiagnosisInflowType["FaqDetail"] = "faq_detail";
    EWebDiagnosisInflowType["HospitalDetail"] = "hospital_detail";
    EWebDiagnosisInflowType["MedicineDictionaryDetail"] = "medicine_dictionary_detail";
    EWebDiagnosisInflowType["NonBenefitMap"] = "non_benefit_map";
    EWebDiagnosisInflowType["NonBenefitHome"] = "non_benefit_home";
    EWebDiagnosisInflowType["DiseaseEncyclopediaDetail"] = "disease_encyclopedia_detail";
    EWebDiagnosisInflowType["MainHomeFooter"] = "main_home_footer";
})(EWebDiagnosisInflowType || (EWebDiagnosisInflowType = {}));
var EScheduleModeForLog;
(function(EScheduleModeForLog) {
    EScheduleModeForLog["Quick"] = "quick";
    EScheduleModeForLog["General"] = "general";
})(EScheduleModeForLog || (EScheduleModeForLog = {}));


/***/ }),

/***/ 54674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pj": function() { return /* reexport */ constants/* EScheduleModeForLog */.pj; },
  "o5": function() { return /* reexport */ constants/* EWebTreatmentRequestLog */.o5; },
  "Js": function() { return /* reexport */ constants/* TreatmentRequestLog */.Js; },
  "cV": function() { return /* reexport */ filteredF2FDaySchedules; }
});

// UNUSED EXPORTS: logs

// EXTERNAL MODULE: ./src/entities/diagnosis/libs/constants.ts
var constants = __webpack_require__(36444);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isSameOrAfter.js
var isSameOrAfter = __webpack_require__(79212);
var isSameOrAfter_default = /*#__PURE__*/__webpack_require__.n(isSameOrAfter);
;// CONCATENATED MODULE: ./src/entities/diagnosis/libs/f2fDaySchedule.ts



dayjs_min_default().extend((isSameOrAfter_default()));
var filteredF2FDaySchedules = function(days, dateToSelect) {
    if (!dateToSelect) return days;
    var base = dayjs_min_default()(dateToSelect);
    var filtered = days.filter(function(d) {
        return dayjs_min_default()(d.targetDate).isSameOrAfter(base, "day");
    });
    return (0,_to_consumable_array/* default */.Z)(filtered);
};

;// CONCATENATED MODULE: ./src/entities/diagnosis/libs/index.ts





/***/ }),

/***/ 96041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G0": function() { return /* binding */ useUnlikeReviewMutation; },
/* harmony export */   "Iu": function() { return /* binding */ useSearchFamilyDoctorsQuery; },
/* harmony export */   "Pk": function() { return /* binding */ useGetDoctorDiagnosisBookingSchedulesQuery; },
/* harmony export */   "St": function() { return /* binding */ useBestDoctorReviewQuery; },
/* harmony export */   "Su": function() { return /* binding */ useGetDoctorByUserQuery; },
/* harmony export */   "WU": function() { return /* binding */ useAddFamilyDoctorMutation; },
/* harmony export */   "Y_": function() { return /* binding */ useGetDoctorReviewQuery; },
/* harmony export */   "iy": function() { return /* binding */ useGetDayOfWeekQuery; },
/* harmony export */   "oC": function() { return /* binding */ useRemoveFamilyDoctorsMutation; },
/* harmony export */   "qd": function() { return /* binding */ useLikeReviewMutation; }
/* harmony export */ });
/* unused harmony exports GetDoctorDiagnosisBookingSchedulesDocument, GetDayOfWeekDocument, LikeReviewDocument, UnlikeReviewDocument, GetDoctorByUserDocument, GetDoctorReviewDocument, BestDoctorReviewDocument, SearchFamilyDoctorsDocument, AddFamilyDoctorDocument, RemoveFamilyDoctorsDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48228);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var GetDoctorDiagnosisBookingSchedulesDocument = "\n    query GetDoctorDiagnosisBookingSchedules($contactType: DiagnosisContactType!, $doctorId: ID!, $telemedicineTargetType: TelemedicineTargetType!) {\n  getDoctorDiagnosisBookingSchedules(\n    request: {doctorId: $doctorId, telemedicineTargetType: $telemedicineTargetType, contactType: $contactType}\n  ) {\n    displayName\n    status\n    targetDate\n    schedules {\n      bookingStatus\n      endTimeSlot {\n        displayTime\n        fromDisplayTime\n        toDisplayTime\n        value\n      }\n      startTimeSlot {\n        displayTime\n        fromDisplayTime\n        toDisplayTime\n        value\n      }\n      remainingCount\n    }\n  }\n}\n    ";
var useGetDoctorDiagnosisBookingSchedulesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetDoctorDiagnosisBookingSchedules",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDoctorDiagnosisBookingSchedulesDocument, "GetDoctorDiagnosisBookingSchedules", variables), options);
};
useGetDoctorDiagnosisBookingSchedulesQuery.getKey = function(variables) {
    return [
        "GetDoctorDiagnosisBookingSchedules",
        variables
    ];
};
useGetDoctorDiagnosisBookingSchedulesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDoctorDiagnosisBookingSchedulesDocument, "GetDoctorDiagnosisBookingSchedules", variables, options);
};
var GetDayOfWeekDocument = "\n    query GetDayOfWeek($date: String!) {\n  dayOfWeek(date: $date)\n}\n    ";
var useGetDayOfWeekQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetDayOfWeek",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDayOfWeekDocument, "GetDayOfWeek", variables), options);
};
useGetDayOfWeekQuery.getKey = function(variables) {
    return [
        "GetDayOfWeek",
        variables
    ];
};
useGetDayOfWeekQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDayOfWeekDocument, "GetDayOfWeek", variables, options);
};
var LikeReviewDocument = "\n    mutation LikeReview($reviewId: ID!) {\n  likeReview(reviewId: $reviewId)\n}\n    ";
var useLikeReviewMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "LikeReview"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(LikeReviewDocument, "LikeReview", variables)();
    }, options);
};
useLikeReviewMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(LikeReviewDocument, "LikeReview", variables, options);
};
var UnlikeReviewDocument = "\n    mutation UnlikeReview($reviewId: ID!) {\n  unlikeReview(reviewId: $reviewId)\n}\n    ";
var useUnlikeReviewMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "UnlikeReview"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(UnlikeReviewDocument, "UnlikeReview", variables)();
    }, options);
};
useUnlikeReviewMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(UnlikeReviewDocument, "UnlikeReview", variables, options);
};
var GetDoctorByUserDocument = "\n    query GetDoctorByUser($doctorPublicId: ID!, $telemedicineEligibleTargetType: TelemedicineTargetType!, $contactType: DiagnosisContactType!, $isSelectedVaccination: Boolean!) {\n  getDoctorByUser(doctorPublicId: $doctorPublicId) {\n    name\n    doctorId\n    readyForVideoCall\n    detail {\n      contractType\n      isBookable\n      isNonBenefitBookable\n      isBookableF2F\n      personalHexColor\n      presentedAt\n      profileImageUrl\n      simpleIntroduce\n      introduce\n      detailImages\n    }\n    reviewCount\n    reviewAverageRating\n    hospital {\n      doctorHospitalId\n      hospitalName\n      hospitalAddress {\n        detailAddress\n        jibunAddress\n        roadAddress\n      }\n      hospitalTelNumber\n      geoPoint {\n        latitude\n        longitude\n      }\n      brand {\n        brandName\n        diagnosisFormType\n      }\n    }\n    medicineType\n    departmentsV2(contactType: $contactType) {\n      description\n      id\n      isProfessional\n      name\n    }\n    reviewTagGroups {\n      count\n      name\n      receiverId\n      receiverType\n      tagId\n    }\n    careers {\n      isRepresentative\n      careerType\n      content\n      id\n      sequence\n    }\n    doctorDuties {\n      f2f {\n        breakEndTime\n        breakStartTime\n        contactType\n        dayOfWeek\n        doctorId\n        endTime\n        hasBreakTime\n        id\n        isClosed\n        startTime\n      }\n      nonF2f {\n        breakEndTime\n        breakStartTime\n        contactType\n        dayOfWeek\n        doctorId\n        endTime\n        hasBreakTime\n        id\n        isClosed\n        startTime\n      }\n    }\n    nonBenefitTreatmentsV2(contactType: $contactType) {\n      nonBenefitTreatmentUnitInfos {\n        doctorTreatmentMedicineUnitPricingId\n        originalPrice\n        priceOnUsingPoint\n        treatmentMedicineName\n        unitDisplayName\n        unitTypeDisplayName\n        usablePoint\n        priceType\n        strengthUnit\n      }\n      treatment {\n        categoryId\n        id\n        isBenefit\n        name\n      }\n    }\n    doctorTreatments {\n      doctorId\n      treatmentId\n      treatment {\n        id\n        name\n      }\n    }\n    treatmentCategoriesV2(contactType: $contactType) {\n      doctorTreatments(contactType: $contactType) {\n        treatment {\n          id\n          name\n        }\n      }\n    }\n    doctorBadges {\n      badges {\n        title\n        description\n        iconUrl\n        type\n      }\n    }\n    doctorNotice {\n      title\n      content\n    }\n    doctorDiagnosisTypeReviewRatingStatistics {\n      diagnosisTypeId\n      diagnosisType\n      name\n      averageRating\n      count\n    }\n    bookingInfo(\n      telemedicineEligibleTargetType: $telemedicineEligibleTargetType\n      contactType: $contactType\n    ) {\n      bookingAvailability\n      doctorId\n      isBookable\n      todayBookable\n      todayCutoffTime\n      todayKickoffTime\n      tomorrowBookable\n      tomorrowCutoffTime\n      tomorrowKickoffTime\n    }\n    bookingSchedules(\n      telemedicineEligibleTargetType: $telemedicineEligibleTargetType\n      contactType: $contactType\n    ) {\n      displayName\n      schedules {\n        startTimeSlot {\n          displayTime\n          fromDisplayTime\n          toDisplayTime\n          value\n        }\n        endTimeSlot {\n          displayTime\n          fromDisplayTime\n          toDisplayTime\n          value\n        }\n        bookingStatus\n        remainingCount\n      }\n      status\n      targetDate\n    }\n    familyDoctorInfo {\n      createdAt\n      doctorId\n    }\n    doctorVaccinations @include(if: $isSelectedVaccination) {\n      treatmentId\n      treatmentName\n      freePolicies {\n        id\n        name\n        targetGroup\n      }\n      vaccinationTypes {\n        vaccinationTypeId\n        name\n        products {\n          vaccineProductId\n          vaccinationTypeUnitId\n          unit\n          price\n          product {\n            name\n          }\n        }\n      }\n    }\n  }\n}\n    ";
var useGetDoctorByUserQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetDoctorByUser",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDoctorByUserDocument, "GetDoctorByUser", variables), options);
};
useGetDoctorByUserQuery.getKey = function(variables) {
    return [
        "GetDoctorByUser",
        variables
    ];
};
useGetDoctorByUserQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDoctorByUserDocument, "GetDoctorByUser", variables, options);
};
var GetDoctorReviewDocument = "\n    query GetDoctorReview($doctorReviewRequest: DoctorReviewRequestInput!, $pagingRequest: PagingRequestInput!, $doctorReviewSort: DoctorReviewSort!) {\n  doctorReview(\n    doctorReviewRequest: $doctorReviewRequest\n    pagingRequest: $pagingRequest\n    doctorReviewSort: $doctorReviewSort\n  ) {\n    doctorId\n    reviewId\n    createdAt\n    content\n    maskedPatientName\n    diagnosisCategoryName\n    comments {\n      createdAt\n      content\n      isBlocked\n    }\n    isPrivate\n    diagnosisId\n    rating\n    tags {\n      tag {\n        tagId\n        text\n      }\n    }\n    title\n    userId\n    isBlocked\n    likeCount\n    isLiked\n    doctor {\n      doctorId\n      medicineType\n      name\n      profileImage\n    }\n  }\n}\n    ";
var useGetDoctorReviewQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetDoctorReview",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDoctorReviewDocument, "GetDoctorReview", variables), options);
};
useGetDoctorReviewQuery.getKey = function(variables) {
    return [
        "GetDoctorReview",
        variables
    ];
};
useGetDoctorReviewQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDoctorReviewDocument, "GetDoctorReview", variables, options);
};
var BestDoctorReviewDocument = "\n    query BestDoctorReview($doctorPublicId: ID!) {\n  bestDoctorReview(doctorPublicId: $doctorPublicId) {\n    doctorId\n    reviewId\n    createdAt\n    content\n    maskedPatientName\n    diagnosisCategoryName\n    comments {\n      createdAt\n      content\n      isBlocked\n    }\n    isPrivate\n    diagnosisId\n    rating\n    tags {\n      tagId\n      tag {\n        text\n      }\n    }\n    title\n    userId\n    isBlocked\n    likeCount\n    isLiked\n    doctor {\n      doctorId\n      medicineType\n      name\n      profileImage\n    }\n  }\n}\n    ";
var useBestDoctorReviewQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "BestDoctorReview",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(BestDoctorReviewDocument, "BestDoctorReview", variables), options);
};
useBestDoctorReviewQuery.getKey = function(variables) {
    return [
        "BestDoctorReview",
        variables
    ];
};
useBestDoctorReviewQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(BestDoctorReviewDocument, "BestDoctorReview", variables, options);
};
var SearchFamilyDoctorsDocument = "\n    query SearchFamilyDoctors($request: FamilyDoctorSearchRequestInput!) {\n  searchFamilyDoctors(request: $request) {\n    familyDoctorCount\n    familyDoctors {\n      createdAt\n      doctorId\n      publicId\n      doctorName\n      hospitalName\n      isAbsent\n      isNew\n      maxWaitingCount\n      medicineType\n      profileUrl\n      readyForVideoCall\n      reviewAverageRating\n      reviewCount\n      professionalDepartment {\n        doctorId\n        professionalDepartmentId\n        professionalDepartmentName\n      }\n      bookingInfo(telemedicineEligibleTargetType: null, contactType: null) {\n        bookingAvailability\n        doctorId\n        isBookable\n        todayBookable\n        todayCutoffTime\n        todayKickoffTime\n        todaySchedule\n        tomorrowBookable\n        tomorrowCutoffTime\n        tomorrowKickoffTime\n        tomorrowSchedule\n      }\n    }\n  }\n}\n    ";
var useSearchFamilyDoctorsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchFamilyDoctors",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchFamilyDoctorsDocument, "SearchFamilyDoctors", variables), options);
};
useSearchFamilyDoctorsQuery.getKey = function(variables) {
    return [
        "SearchFamilyDoctors",
        variables
    ];
};
useSearchFamilyDoctorsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchFamilyDoctorsDocument, "SearchFamilyDoctors", variables, options);
};
var AddFamilyDoctorDocument = "\n    mutation AddFamilyDoctor($doctorId: ID!) {\n  addFamilyDoctor(doctorId: $doctorId)\n}\n    ";
var useAddFamilyDoctorMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "AddFamilyDoctor"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(AddFamilyDoctorDocument, "AddFamilyDoctor", variables)();
    }, options);
};
useAddFamilyDoctorMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(AddFamilyDoctorDocument, "AddFamilyDoctor", variables, options);
};
var RemoveFamilyDoctorsDocument = "\n    mutation RemoveFamilyDoctors($doctorIds: [ID!]!) {\n  removeFamilyDoctors(request: {doctorIds: $doctorIds})\n}\n    ";
var useRemoveFamilyDoctorsMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "RemoveFamilyDoctors"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(RemoveFamilyDoctorsDocument, "RemoveFamilyDoctors", variables)();
    }, options);
};
useRemoveFamilyDoctorsMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(RemoveFamilyDoctorsDocument, "RemoveFamilyDoctors", variables, options);
};


/***/ }),

/***/ 82080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ request_complete; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(4601);
// EXTERNAL MODULE: ./src/components/atom/buttons/StickyButton.tsx
var StickyButton = __webpack_require__(91707);
// EXTERNAL MODULE: ./src/components/common/ClickLogger.tsx
var ClickLogger = __webpack_require__(53157);
// EXTERNAL MODULE: ./src/entities/diagnosis/libs/index.ts + 1 modules
var libs = __webpack_require__(54674);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/constants/logs/deeplink/index.ts
var deeplink = __webpack_require__(60643);
// EXTERNAL MODULE: ./src/hooks/doctor/useGetDoctorByUser.ts + 1 modules
var useGetDoctorByUser = __webpack_require__(37417);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 1 modules
var hooks = __webpack_require__(95613);
// EXTERNAL MODULE: ./src/shared/types/index.ts + 1 modules
var types = __webpack_require__(9628);
// EXTERNAL MODULE: ./src/types/diagnosis.ts
var diagnosis = __webpack_require__(20138);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/views/telemedicine/request-complete/hooks/useTelemedicineRequestCompleteViewModel.ts








var useTelemedicineRequestCompleteViewModel = function() {
    var router = (0,next_router.useRouter)();
    var airbridgeDynamicLink = (0,hooks/* useAirbridgeDynamicLink */.e)("web_treatment_request_complete");
    var _query = router.query, diagnosisDate = _query.diagnosisDate, medicalCategoryName = _query.medicalCategoryName, doctorId = _query.doctorId, pid = _query.pid;
    var ref = (0,useGetDoctorByUser/* default */.ZP)({
        doctorId: doctorId || "",
        contactType: diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F
    }), doctorDetail = ref.doctorDetail, isDoctorDetailLoading = ref.isDoctorDetailLoading;
    var doctorName = (0,react.useMemo)(function() {
        var ref;
        return (doctorDetail === null || doctorDetail === void 0 ? void 0 : (ref = doctorDetail.doctor) === null || ref === void 0 ? void 0 : ref.name) || "";
    }, [
        doctorDetail
    ]);
    var doctorImage = (0,react.useMemo)(function() {
        var ref;
        return doctorDetail === null || doctorDetail === void 0 ? void 0 : (ref = doctorDetail.doctor) === null || ref === void 0 ? void 0 : ref.profileImageUrl;
    }, [
        doctorDetail
    ]);
    var onHomeClick = (0,react.useCallback)(function() {
        router.push("/");
    }, [
        router
    ]);
    var handleClickAppButton = (0,react.useCallback)(function() {
        airbridgeDynamicLink.navigateWithTracking(deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton, (0,_object_spread/* default */.Z)({
            campaign: "web_treatment_request_complete",
            term: "앱에서 진료 현황보기"
        }, doctorId && {
            sub_id: doctorId
        }, medicalCategoryName && {
            sub_id_1: medicalCategoryName
        }), types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL);
    }, [
        doctorId,
        medicalCategoryName,
        airbridgeDynamicLink
    ]);
    (0,react.useEffect)(function() {
        var handlePopState = function() {
            router.replace("/");
        };
        window.addEventListener("popstate", handlePopState);
        return function() {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [
        router
    ]);
    return {
        doctorId: doctorId,
        onHomeClick: onHomeClick,
        diagnosisDate: diagnosisDate || "",
        medicalCategoryName: medicalCategoryName || "",
        doctorName: doctorName,
        doctorImage: doctorImage,
        isLoading: isDoctorDetailLoading || !router.isReady,
        pid: pid,
        handleClickAppButton: handleClickAppButton
    };
};
/* harmony default export */ var hooks_useTelemedicineRequestCompleteViewModel = (useTelemedicineRequestCompleteViewModel);

;// CONCATENATED MODULE: ./src/views/telemedicine/request-complete/ui/TelemedicineRequestCompleteView.tsx






var DEFAULT_DOCTOR_IMAGE = "/images/doctor-placeholder.png";
var TelemedicineRequestCompleteView = function() {
    var viewModel = hooks_useTelemedicineRequestCompleteViewModel();
    if (viewModel.isLoading) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex min-h-screen flex-col bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle, {
                    doctorName: viewModel.doctorName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-1 flex-col items-center justify-center gap-[32px] px-[24px] pt-[218px] pb-[114px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorImage, {
                            doctorImage: viewModel.doctorImage || DEFAULT_DOCTOR_IMAGE
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppointmentInfoCard, {
                            diagnosisDate: viewModel.diagnosisDate,
                            medicalCategoryName: viewModel.medicalCategoryName,
                            doctorName: viewModel.doctorName
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                    params: {
                        eventName: libs/* EWebTreatmentRequestLog.ClickCtaButton */.o5.ClickCtaButton,
                        payload: {
                            doctorId: viewModel.doctorId || ""
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingButton, {
                        onClick: viewModel.handleClickAppButton,
                        onHomeClick: viewModel.onHomeClick
                    })
                })
            ]
        })
    });
};
var PageTitle = function(param) {
    var doctorName = param.doctorName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "absolute top-[60px] right-0 left-0 flex flex-col gap-[8px] px-[24px] pt-[12px] pb-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "typography-ui-24sb w-full text-gray-900",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mb-0",
                        children: [
                            doctorName,
                            " 선생님이"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "신청서를 확인하고 있어요"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "typography-ui-17r w-full text-gray-600",
                children: "진료가 확정되면 카톡으로 알려드릴게요."
            })
        ]
    });
};
var DoctorImage = function(param) {
    var doctorImage = param.doctorImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex w-full flex-col items-center justify-center overflow-hidden pt-0 pb-[40px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mb-[-40px] size-[200px] shrink-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: doctorImage,
                    alt: "의사 이미지",
                    className: "pointer-events-none size-full object-cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-[-40px] h-[40px] w-full bg-gradient-to-b from-transparent to-white"
            })
        ]
    });
};
var AppointmentInfoCard = function(param) {
    var diagnosisDate = param.diagnosisDate, medicalCategoryName = param.medicalCategoryName, doctorName = param.doctorName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-full flex-col gap-[12px] rounded-[12px] bg-gray-20 p-[20px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoRow, {
                label: "예상 진료 시간",
                value: diagnosisDate,
                isHighlight: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoRow, {
                label: "증상/과목",
                value: medicalCategoryName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoRow, {
                label: "의사명",
                value: "".concat(doctorName, " 의사")
            })
        ]
    });
};
var InfoRow = function(param) {
    var label = param.label, value = param.value, _isHighlight = param.isHighlight, isHighlight = _isHighlight === void 0 ? false : _isHighlight;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-full items-center gap-[16px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "typography-ui-15r shrink-0 whitespace-pre text-gray-400",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "typography-ui-15m grow basis-0 text-right ".concat(isHighlight ? "text-primary-700" : "text-gray-700"),
                children: value
            })
        ]
    });
};
var Divider = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-[1px] w-full shrink-0 bg-gray-40"
    });
};
var FloatingButton = function(param) {
    var onClick = param.onClick, onHomeClick = param.onHomeClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col gap-[12px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                    params: {
                        eventName: libs/* EWebTreatmentRequestLog.ClickCompleteButton */.o5.ClickCompleteButton
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        size: "xl",
                        buttonColor: "primary",
                        buttonStyle: "contained",
                        onClick: onClick,
                        className: "w-full",
                        children: "앱에서 진료 현황보기"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                    params: {
                        eventName: libs/* EWebTreatmentRequestLog.ClickCompleteButton */.o5.ClickCompleteButton
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        size: "xl",
                        buttonColor: "gray",
                        buttonStyle: "outlined",
                        onClick: onHomeClick,
                        className: "w-full",
                        children: "홈으로 돌아가기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ui_TelemedicineRequestCompleteView = (TelemedicineRequestCompleteView);

;// CONCATENATED MODULE: ./src/views/telemedicine/request-complete/ui/index.ts



;// CONCATENATED MODULE: ./src/views/telemedicine/request-complete/hooks/index.ts



;// CONCATENATED MODULE: ./src/views/telemedicine/request-complete/index.ts



;// CONCATENATED MODULE: ./src/pages/telemedicine/request-complete/index.tsx
// PageDescription: 비대면진료 웹 진료 신청 완료 페이지


var TelemedicineRequestCompletePage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TelemedicineRequestCompleteView, {});
};
/* harmony default export */ var request_complete = (TelemedicineRequestCompletePage);


/***/ }),

/***/ 48228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ useMutation; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(464);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/mutation.mjs
var mutation = __webpack_require__(89886);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/mutationObserver.mjs





// CLASS
class MutationObserver extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.client = client;
    this.setOptions(options);
    this.bindMethods();
    this.updateResult();
  }

  bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  }

  setOptions(options) {
    const prevOptions = this.options;
    this.options = this.client.defaultMutationOptions(options);

    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.client.getMutationCache().notify({
        type: 'observerOptionsUpdated',
        mutation: this.currentMutation,
        observer: this
      });
    }
  }

  onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  }

  onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    const notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  }

  getCurrentResult() {
    return this.currentResult;
  }

  reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  }

  mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, { ...this.options,
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    });
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  }

  updateResult() {
    const state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();
    const result = { ...state,
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = result;
  }

  notify(options) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      // First trigger the mutate callbacks
      if (this.mutateOptions) {
        if (options.onSuccess) {
          var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;

          (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null ? void 0 : _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (options.onError) {
          var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;

          (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null ? void 0 : _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        this.listeners.forEach(listener => {
          listener(this.currentResult);
        });
      }
    });
  }

}


//# sourceMappingURL=mutationObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/utils.mjs
var lib_utils = __webpack_require__(24798);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs






function useMutation(arg1, arg2, arg3) {
  const options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const [observer] = react.useState(() => new MutationObserver(queryClient, options));
  react.useEffect(() => {
    observer.setOptions(options);
  }, [observer, options]);
  const result = (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)), [observer]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  const mutate = react.useCallback((variables, mutateOptions) => {
    observer.mutate(variables, mutateOptions).catch(noop);
  }, [observer]);

  if (result.error && (0,lib_utils/* shouldThrowError */.L)(observer.options.useErrorBoundary, [result.error])) {
    throw result.error;
  }

  return { ...result,
    mutate,
    mutateAsync: result.mutate
  };
} // eslint-disable-next-line @typescript-eslint/no-empty-function

function noop() {}


//# sourceMappingURL=useMutation.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7417,9774,2888,179], function() { return __webpack_exec__(24935); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);